/* components/ProductsFilters
- Used within collection and search templates

Example
<collection-filters>
    [[collection filters content]]
</collection-filters>
*/

import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class CollectionFilters extends ThemeComponent {
    @Ref()
    details!: HTMLDListElement[];

    init() {
        this.handleDetailsOpen(this.details);
    }

    private handleDetailsOpen(details: HTMLDListElement[]) {
        for (const detail of details) {
            detail.addEventListener("click", () => {
                for (const sibling of details) {
                    if (detail !== sibling) {
                        sibling.removeAttribute("open");
                    }
                }
            });
        }
    }
}
